import React from 'react'

export default function RoomCount({roomCount}) {
  return (
    <>
    <section className="roomdetail-count">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="roomcount-row">
                        <div>
                            <img src="/image/roomdetail-icon-1.webp" alt="icon"/>
                            <span>{roomCount.bedroom}</span>
                            <p>Bedroom</p>
                        </div>

                        <div>
                            <img src="/image/roomdetail-icon-2.webp" alt="icon"/>
                            <span>{roomCount.bedsize}</span>
                            <p>Size Bed</p>
                        </div>

                        <div>
                            <img src="/image/roomdetail-icon-3.webp" alt="icon"/>
                            <span>{roomCount.area} m<sup>2</sup></span>
                            <p>Room Area</p>
                        </div>

                        <div>
                            <img src="/image/roomdetail-icon-4.webp" alt="icon"/>
                            <span>{roomCount.bathroom}</span>
                            <p>Bathroom</p>
                        </div>

                        <div>
                            <img src="/image/roomdetail-icon-5.webp" alt="icon"/>
                            <span>{roomCount.guest}</span>
                            <p>MAX Guests</p>
                        </div>

                        <div>
                            <img src="/image/roomdetail-icon-6.webp" alt="icon"/>
                            <span>{roomCount.balcony}</span>
                             <p>{roomCount.viewLabel || "Balcony View"}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}
